import { EuEmptyState } from '@newamsterdam/ui'

export interface PlaceholderProps {
  title: string
  hint?: string
}

export function Placeholder({ title, hint }: PlaceholderProps) {
  return <EuEmptyState title={title} description={hint} />
}
